import { render, staticRenderFns } from "./CustomersFormInstitutionPrices.vue?vue&type=template&id=b34d9d90&"
import script from "./CustomersFormInstitutionPrices.vue?vue&type=script&lang=js&"
export * from "./CustomersFormInstitutionPrices.vue?vue&type=script&lang=js&"
import style0 from "./CustomersFormInstitutionPrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports